(function () {
	'use strict';
	angular.module('dcApp').service('DepotUtils', DepotUtils);

	DepotUtils.$inject = ['gettextCatalog', 'toaster'];

	function DepotUtils(gettextCatalog, toaster) {
		this.initReaderTypes = [
			{
				value: 'CSV',
				label: gettextCatalog.getString('Fichier avec séparateur'),
				supportedConnectors: ['HTTP', 'LOCAL', 'S3', 'SFTP', 'HDFS'],
			},
			{
				value: 'SQL',
				label: gettextCatalog.getString('Syntaxe SQL'),
				supportedConnectors: ['SQL'],
			},
			{
				value: 'PARQUET',
				label: gettextCatalog.getString('Fichier Parquet'),
				supportedConnectors: ['HTTP', 'S3', 'SFTP', 'HDFS', 'LOCAL'],
			},
			{
				value: 'JSON',
				label: gettextCatalog.getString('Fichier JSON'),
				supportedConnectors: ['HTTP', 'S3', 'SFTP', 'HDFS', 'LOCAL'],
			},
			{
				value: 'JSON_V2',
				label: gettextCatalog.getString('Fichier JSON') + ' V2',
				supportedConnectors: ['HTTP', 'S3', 'SFTP', 'HDFS', 'LOCAL'],
			},
			{
				value: 'EXCEL',
				label: gettextCatalog.getString('Fichier Excel'),
				supportedConnectors: ['HTTP', 'S3', 'SFTP', 'HDFS', 'LOCAL'],
			},
			{
				value: 'BINARY',
				label: gettextCatalog.getString('Fichier Binaire (Tous fichiers)'),
				supportedConnectors: ['SFTP', 'HDFS', 'S3', 'LOCAL'],
			},
			{
				value: 'MONGODB',
				label: gettextCatalog.getString('Collection MongoDB'),
				supportedConnectors: ['MONGODB'],
			},
			{
				value: 'NEO4J',
				label: gettextCatalog.getString('depot.reader.no4j'),
				supportedConnectors: ['NEO4J'],
			},
			{
				value: 'TRINO',
				label: gettextCatalog.getString('depot.reader.trino'),
				supportedConnectors: ['TRINO'],
			},
			{
				value: 'XML',
				label: gettextCatalog.getString('Fichier XML'),
				supportedConnectors: ['HTTP', 'LOCAL', 'S3', 'SFTP', 'HDFS'],
			},
			{
				value: 'XML_V2',
				label: gettextCatalog.getString('Fichier XML') + ' V2',
				supportedConnectors: ['HTTP', 'LOCAL', 'S3', 'SFTP', 'HDFS'],
			},
		];

		this.dataTypes = [
			{
				label: gettextCatalog.getString('Chaîne de caractères'),
				value: 'StringType',
			},
			{
				label: gettextCatalog.getString('Booléen'),
				value: 'BooleanType',
			},
			{
				label: gettextCatalog.getString('Horodatage (Timestamp)'),
				value: 'TimestampType',
			},
			{
				label: gettextCatalog.getString('Nombre décimal'),
				value: 'DecimalType',
			},
			{
				label: gettextCatalog.getString('Grand nombre entier'),
				value: 'LongType',
			},
			{
				label: gettextCatalog.getString('Nombre entier (<2 Md)'),
				value: 'IntegerType',
			},
			{
				label: gettextCatalog.getString('Données binaires'),
				value: 'BinaryType',
			}
		];

		this.connectorsTypes = [
			{ value: 'SQL', label: 'Base De Données' },
			{ value: 'HTTP', label: 'HTTP' },
			{
				value: 'S3',
				label: 'S3-AWS',
			},
			{
				value: 'SFTP',
				label: 'SFTP',
			},
		];

		this.filtersDateOperators = [
			{ value: 'ALL', label: gettextCatalog.getString('Toutes') },
			{ value: 'LAST', label: gettextCatalog.getString('Dernier') },
			{ value: 'FIRST', label: gettextCatalog.getString('Premier') },
			{ value: 'BEFORE', label: gettextCatalog.getString('Avant') },
			{
				value: 'AFTER',
				label: gettextCatalog.getString('Après'),
			},
			{ value: 'BETWEEN', label: gettextCatalog.getString('Entre') },
			{
				value: 'WEEK_IN_MONTH',
				label: gettextCatalog.getString('Numéro de semaine dans le mois'),
			},
			{
				value: 'WEEK_IN_YEAR',
				label: gettextCatalog.getString("Numéro de semaine dans l'année"),
			},
			{
				value: 'DAY_IN_WEEK',
				label: gettextCatalog.getString('Numéro de jour dans la semaine'),
			},
			{
				value: 'DAY_IN_MONTH',
				label: gettextCatalog.getString('Numéro de jour dans le mois'),
			},
			{
				value: 'DAY_IN_YEAR',
				label: gettextCatalog.getString("Numéro de jour dans l'année"),
			},
		];

		this.possibleCurrentVersionMaskValues = [
			'*.{csv,CSV,cSv,cSV,Csv,CSv,csV,CsV}',
			'*.{txt,TXT,tXt,tXT,Txt,TXt,txT,TxT}',
			'*.{xls,xlsx,XLS,xLs,xLS,Xls,XLs,xlS,XlS}',
			'*.{pdf,PDF,pDf,pDF,Pdf,PDf,pdF,PdF}',
			'*.{xls,XLS,xLs,xLS,Xls,XLs,xlS,XlS,csv,CSV,cSv,cSV,Csv,CSv,csV,CsV,txt,TXT,tXt,tXT,Txt,TXt,txT,TxT}',
			'*.{json,Json,JSON}',
			'*.{parquet, Parquet, PARQUET}',
			'*.{xml,XML,Xml,XMl,xML,xmL,XmL}',
		];

		this.httpIterationModes = [
			{ label: gettextCatalog.getString('Sans'), value: 'WITHOUT' },
			{ label: gettextCatalog.getString('Par Page'), value: 'PER_PAGE' },
			{
				label: gettextCatalog.getString('Par Offset'),
				value: 'PER_OFFSET',
			},
		];

		this.httpIterationEndModes = [
			{ label: gettextCatalog.getString('Sans REGEX'), value: false },
			{ label: gettextCatalog.getString('Avec REGEX'), value: true },
		];

		this.depotTypeLib = function (type) {
			switch (type) {
				case 'CSV':
					return gettextCatalog.getString('Fichier avec séparateur');
				case 'SQL':
					return gettextCatalog.getString('Syntaxe SQL');
				case 'MONGODB':
					return gettextCatalog.getString('Collection MongoDB');
				case 'PARQUET':
					return gettextCatalog.getString('Fichier Parquet');
				case 'NEO4J':
					return gettextCatalog.getString('depot.reader.no4j');
				case 'TRINO':
					return gettextCatalog.getString('depot.reader.trino');
				case 'JSON':
				case 'JSON_V2':
					return gettextCatalog.getString('Fichier JSON');
				case 'BINARY':
					return gettextCatalog.getString('Fichier Binaire (Tous fichiers)');
				case 'EXCEL':
					return gettextCatalog.getString('Fichier Excel');
				case 'XML':
				case 'XML_V2':
					return gettextCatalog.getString('Fichier XML');
				default:
					return '';
			}
		};

		this.notifyOnDeleteHeadersSuccess = function () {
			toaster.pop(
				'success',
				gettextCatalog.getString('Succès'),
				gettextCatalog.getString(
					'depot.headers.delete.all'
				)
			);
		};

		this.notifyOnDeleteFile = function (isSuccess) {
			isSuccess
				? toaster.pop(
						'success',
						gettextCatalog.getString('Succès'),
						gettextCatalog.getString("Suppression de l'entête effectuée")
				  )
				: toaster.pop(
						'error',
						gettextCatalog.getString('Opération non supportée'),
						gettextCatalog.getString(
							'Opération uniquement possible pour les Dépôts utilisant un Connecteur LOCAL ou HDFS'
						)
				  );
		};

		this.notifyOnDeleteEntityFileMapping = function () {
			toaster.pop(
				'success',
				gettextCatalog.getString('Succès'),
				gettextCatalog.getString('Lien Entité métier-Dépôt effectué')
			);
		};

		this.notifyOnCreateDepotExtraction = function () {
			toaster.pop(
				'success',
				gettextCatalog.getString('Succès'),
				gettextCatalog.getString('Extraction effectuée')
			);
		};

		this.notifyOnDeleteExtraction = function (isSuccess) {
			toaster.pop(
				'success',
				gettextCatalog.getString('Succès'),
				gettextCatalog.getString("Suppression de l'Extraction effectuée")
			);
		};

		this.notifyOnDeleteFilter = function (isSuccess) {
			toaster.pop(
				'success',
				gettextCatalog.getString('Succès'),
				gettextCatalog.getString('Suppression du filtre effectuée')
			);
		};

		this.notifyOnAddEditFilter = function (isSuccess) {
			toaster.pop(
				'success',
				gettextCatalog.getString('Succès'),
				gettextCatalog.getString('Ajout du filtre Extraction effectué')
			);
		};

		this.notifyOnDepotAction = function (action, isSuccess, depotType) {
			if (action === 'create') {
				toaster.pop(
					'success',
					gettextCatalog.getString('Succès'),
					`${gettextCatalog.getString(
						'Création du Dépôt'
					)} ${depotType} ${gettextCatalog.getString('effectuée')}`
				);
			} else if (action === 'save') {
				toaster.pop(
					'success',
					gettextCatalog.getString('Succès'),
					`${gettextCatalog.getString(
						'Modification du Dépôt'
					)} ${depotType} ${gettextCatalog.getString('effectuée')}`
				);
			} else if (action === 'delete') {
				toaster.pop(
					'success',
					gettextCatalog.getString('Succès'),
					`${gettextCatalog.getString(
						'Suppression du Dépôt'
					)} ${depotType} ${gettextCatalog.getString('effectuée')}`
				);
			}
		};

		this.notifyOnFileUploadError = function (action, fileName) {
			if (action === 'invalidMask') {
				toaster.pop(
					'error',
					gettextCatalog.getString('Erreur'),
					gettextCatalog.getString('Le fichier') +
						" '" +
						fileName +
						"' " +
						gettextCatalog.getString('ne correspond pas au masque de lecture')
				);
			} else if (action === 'invalidFileSize') {
				toaster.pop(
					'error',
					gettextCatalog.getString('Erreur'),
					gettextCatalog.getString('Le fichier') +
						" '" +
						fileName +
						"' " +
						gettextCatalog.getString('est trop grand')
				);
			}
		};

		this.notifyOnMissingConnector = function () {
			toaster.pop(
				'error',
				gettextCatalog.getString('Erreur'),
				gettextCatalog.getString('Un Connecteur est obligatoire !')
			);
		};

		this.notifyOnHeaderAction = function (action, isSuccess) {
			if (action === 'edit') {
				toaster.pop(
					'success',
					gettextCatalog.getString('Succès'),
					gettextCatalog.getString("Modification de l'entête effectuée")
				);
			} else if (action === 'add') {
				toaster.pop(
					'success',
					gettextCatalog.getString('Succès'),
					gettextCatalog.getString('Entête ajouté')
				);
			} else if (action === 'update') {
				toaster.pop(
					'success',
					gettextCatalog.getString('Succès'),
					gettextCatalog.getString('Mise à jour des entêtes effectuée')
				);
			} else if (action === 'delete') {
				toaster.pop(
					'success',
					gettextCatalog.getString('Succès'),
					gettextCatalog.getString("Suppression de l'entête effectuée")
				);
			}
		};

		this.notifyOnDataBaseDepotTypeEdit = function (dbType) {
			if (dbType === undefined || dbType === null || dbType === '') {
				toaster.pop(
					'success',
					gettextCatalog.getString('Succès'),
					gettextCatalog.getString(
						'Modification du Dépôt Base de données effectuée'
					)
				);
			} else if (dbType === 'MONGO_DB') {
				toaster.pop(
					'success',
					gettextCatalog.getString('Succès'),
					gettextCatalog.getString('Modification du Dépôt') +
						this.depotTypeLib('MONGODB') +
						gettextCatalog.getString('effectuée')
				);
			} else if (dbType === 'NEO4J') {
				toaster.pop(
					'success',
					gettextCatalog.getString('Succès'),
					gettextCatalog.getString('Modification du Dépôt') +
						this.depotTypeLib('NEO4J') +
						gettextCatalog.getString('effectuée')
				);
			} else if (dbType === 'TRINO') {
				toaster.pop(
					'success',
					gettextCatalog.getString('Succès'),
					gettextCatalog.getString('Modification du Dépôt') +
						this.depotTypeLib('TRINO') +
						gettextCatalog.getString('effectuée')
				);
			}
		};
	}
})();
